// Chakra imports
import {Box, SimpleGrid} from "@chakra-ui/react";
import React from "react";
import PatientListing from "../pages/PatientListing.tsx";

export default function PatientList() {
    // Chakra Color Mode
    return (
        <Box pt={{base: "130px", md: "80px", xl: "80px"}}>
            <SimpleGrid
                mb='20px'
                columns={{sm: 1, md: 0}}
                spacing={{base: "20px", xl: "20px"}}>
                {/*<CheckTable columnsData={columnsDataCheck} tableData={tableDataCheck} />*/}
                <PatientListing/>
            </SimpleGrid>
        </Box>
    );
}
